import * as actionTypes from "./actionTypes"

export const fetchMaintenanceMode = () => ({
  type: actionTypes.FETCH_MAINTENANCE_MODE,
})

export const fetchMaintenanceModeSuccess = (isMaintenanceMode) => ({
  type: actionTypes.FETCH_MAINTENANCE_MODE_SUCCESS,
  payload: isMaintenanceMode,
})

export const fetchMaintenanceModeFailure = (error) => ({
  type: actionTypes.FETCH_MAINTENANCE_MODE_FAILURE,
  payload: error,
})

export const setMaintenanceMode = (isMaintenanceMode) => ({
  type: actionTypes.SET_MAINTENANCE_MODE,
  payload: isMaintenanceMode,
})
